import { render, staticRenderFns } from "./contrato-productores.vue?vue&type=template&id=71626896&lang=html"
import script from "./contrato-productores.vue?vue&type=script&lang=js"
export * from "./contrato-productores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports